export default "__VITE_ASSET__v63LTHrP__"